var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15259 45C4.41265 44.998 3.68177 44.8371 3.00943 44.5281C2.33709 44.2192 1.73897 43.7693 1.25556 43.2091C0.772157 42.6489 0.414748 41.9914 0.207526 41.2811C0.000304269 40.5707 -0.0518926 39.8242 0.0544685 39.0919C0.540093 35.7057 2.17884 29.4657 4.50384 27.1407C6.27541 25.3696 8.67797 24.3748 11.183 24.3752C13.688 24.3755 16.0903 25.371 17.8613 27.1425C19.6324 28.9141 20.6272 31.3167 20.6268 33.8217C20.6265 36.3267 19.631 38.729 17.8595 40.5C15.5363 42.8232 9.29634 44.4619 5.90822 44.9475C5.65798 44.9836 5.40542 45.0011 5.15259 45ZM43.3126 1.68753C42.2182 0.645068 40.7647 0.0635986 39.2532 0.0635986C37.7418 0.0635986 36.2883 0.645068 35.1938 1.68753L15.5063 21.375C17.3895 22.0232 19.0999 23.0929 20.5069 24.5025C21.9139 25.9121 22.9804 27.6244 23.6251 29.5088L43.3126 9.80628C44.3864 8.72815 44.9892 7.26852 44.9892 5.7469C44.9892 4.22529 44.3864 2.76565 43.3126 1.68753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen_icon.d4ca08eb5ce0d8672dea7834f0c092ca.svg";
export { ForwardRef as ReactComponent };